export enum BookingsFiltersValues {
  Upcoming = 'upcoming',
  Completed = 'completed',
  Cancelled = 'cancelled'
}
